import commonRepo from '@/repository/common.repo'
import { localStorageService } from '@/service/storage.service'

// "나의 DB 문제 포함" 체크박스 영속화 정책: 디폴트 ON, 최종 생성 시점 값을 저장해 1단계 진입 시 복원한다.
// 권한이 없으면 체크박스가 숨겨져 사용자가 끌 수 없으므로, 저장값과 무관하게 false 로 고정해
// includeMyDbProblem: true 가 생성 요청에 실려나가는 것을 막는다.
export const getStoredIncludeMyDbProblem = () =>
  commonRepo.isMyDbAllowed &&
  (localStorageService.getItem('MY_DB_SIMILAR_RECOMMEND_TOGGLE') ?? true)

export const storeIncludeMyDbProblem = (includeMyDbProblem: boolean) => {
  localStorageService.setItem('MY_DB_SIMILAR_RECOMMEND_TOGGLE')(includeMyDbProblem)
}
